import { Component } from '@angular/core';

@Component({
  selector: 'lib-select-renderer',
  standalone: true,
  imports: [],
  templateUrl: './select-renderer.component.html',
  styleUrl: './select-renderer.component.css'
})
export class SelectRendererComponent {
  public params: any;
  public disabled: boolean;

  public displayValue: string = '';

  public agInit(params: any): void {
    this.params = params;
    const data = this.params.data;
    // show cursor: not-allow to let user know this field is not editabled
    // based on column key existence in the row model
    // or if the row is loading/validating
    if (typeof params.column.colDef.editable == 'function') {
      this.disabled = !params.column.colDef.editable(params);
    } else {
      this.disabled = !params.column.colDef.editable;
    }
    const val = this.params.values.find((v: any) => v.value == this.params.value);
    if (val != null) {
      this.displayValue = val.label;
    }
  }
}
